import React, { useEffect, useState, useRef, Fragment, forwardRef, useImperativeHandle, UIEventHandler, useContext, useMemo } from "react";
import { useRequest } from "ahooks"
import { getControlNodeLinesAPI, updateControlNodeStatusAPI, getProjectMultiplePaymentNodes, updateControlLineSortAPI, getProjectPaymentExpenseLinks, getTHPaymentNodesAPI, getProjectPaymentContractNodesApi } from "@/services"
import type { MainPackageContract, SubPackageContract } from "./types"
import { parseTime } from "@/utils";

export const usePayablesData = (projectID: string) => {
    // 总包合同
    const { data: contactsPaymentNodes = [], loading: mainLoading } = useRequest(async (projectID: string) => {
        const contractNodes = await getProjectPaymentContractNodesApi(projectID)
        // const res = await getProjectMultiplePaymentNodes(projectID, codes)
        const result: MainPackageContract[] = []
        const curDate = new Date()
        curDate.setHours(0, 0, 0, 0)
        const contractMap = new Map<string, MainPackageContract>()
        contractNodes.forEach(item => {
            if (item.salesContractCode) {
                let mapItem = contractMap.get(item.salesContractCode)

                if (!mapItem) {
                    mapItem = {
                        name: item.salesContractName || "",
                        code: item.salesContractCode || "",
                        nodes: [{
                            ...item,
                            date: parseTime(item.date, "{y}-{m}-{d}"),
                            percent: Number(item.contractMilestoneReceived) / Number(item.contractMilestoneAmount) || 0,
                        }]
                    }
                } else {
                    mapItem.nodes.push({
                        ...item,
                        percent: Number(item.contractMilestoneReceived) / Number(item.contractMilestoneAmount) || 0,
                        date: parseTime(item.date, "{y}-{m}-{d}")
                    })
                }
                contractMap.set(item.salesContractCode, mapItem)
            }
        })

        contractMap.forEach(item => {
            item.nodes.sort((a, b) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime()
            })
            result.push(item)
        })
        return result
    }, {
        defaultParams: [projectID],
    });
    // 关联信息
    const { data: paymentExpenseLinks = [], refresh: refreshPaymentExpenseLinks } = useRequest(getProjectPaymentExpenseLinks, {
        defaultParams: [projectID],
    })
    // 分包合同
    const { data: expenseLinesDataOri = [], loading: subLoading } = useRequest(async (projectID: string) => {
        const res = await getTHPaymentNodesAPI(projectID) || []
        const map = new Map<string, SubPackageContract>()
        res.forEach(item => {
            let mapItem = map.get(item.purContractCode)
            
            if (!mapItem) {
                mapItem = {
                    code: item.purContractCode,
                    name: item.purContractName,
                    nodes: [{
                        ...item,
                        percent: Number(item.paymentConditionReceived) / Number(item.paymentConditionAmount) || 0,
                    }]
                }
            }else{
                mapItem.nodes.push({
                    ...item,
                    percent: Number(item.paymentConditionReceived) / Number(item.paymentConditionAmount) || 0,
                })
            }
            map.set(item.purContractCode, mapItem)
        })
        let result: SubPackageContract[] = Array.from(map.values())
        result = result.map(item => {
            item.hasCanPayment = item.nodes.some((v) => {
                return v.status === "可付款"
            })
            return item
        })
        return result
    }, {
        defaultParams: [projectID]
    })

    return {
        mainPackageContracts: contactsPaymentNodes,
        subPackageContracts: expenseLinesDataOri,
        links: paymentExpenseLinks,
        loading: mainLoading || subLoading
    }
}

